
















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as _ from 'underscore';
import moment from 'moment-timezone'

import { bookingSearchInfoType } from '@/types/Common';


@Component
export default class BookingTable extends Vue {

    @Prop({required: true})
    bookings!: bookingSearchInfoType[];
    
 
    bookingDataReady = false;
    updatedBookingInfo = 0;

    showCancelBookingWindow = false; 
    booking = {} as bookingSearchInfoType;

    bookingFields = [        
        {key:'spotNumber',     label:'Parking Spot Number', sortable:false,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'spotType',       label:'Parking Spot Type',   sortable:false,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'license_plate',   label:'License Plate Number',sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'start_date',      label:'Start',               sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'end_date',        label:'End',                 sortable:true,  cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'past',           label:'',                    sortable:false, cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', },
        {key:'cancel',         label:'',                    sortable:false, cellStyle:'', thClass:'bg-primary text-white align-middle', tdClass:'align-middle', }
    ];
    mobile = false;

    mounted() { 
        this.booking = {} as bookingSearchInfoType;   
        this.bookingDataReady = false;
        this.mobile = false;
        if (window.innerWidth < 600) {
            this.mobile = true;
        }
    }
    
    public closeCancelBookingWindow(){
        this.showCancelBookingWindow = false;
    }   
    
    public confirmCancelBooking(bookingToCancel: bookingSearchInfoType){        
        this.booking = JSON.parse(JSON.stringify(bookingToCancel));
        this.showCancelBookingWindow = true;
        this.bookingDataReady = true;
    }

    public cancelBooking(){       
        
        this.$http.delete('/booking/' + this.booking.id)
        .then((response) => {            
            this.closeCancelBookingWindow();
            this.$emit('find'); 
            this.bookingDataReady = true;             
        },(err) => {
            this.bookingDataReady = true;         
        });       
        
    }  

    public pastBooking(endDate){
        const current = moment().format()
        if(endDate<=current) return true;
        return false;
    }

}
